import styled, { css } from 'styled-components'
import { Spacing, Colors, Typography } from 'cio-design-library/design-tokens'
import { SegmentControl, SegmentControls } from 'builder/components/SegmentControls'
import { EditorPanelSwitcherTheme } from './types'

type Props = {
  $theme: EditorPanelSwitcherTheme
  $isFullWidth?: boolean
}

export const StyledSegmentControls = styled(SegmentControls)<Props>`
  ${({ $theme }) => {
    switch ($theme) {
      case 'default':
        return css`
          background-color: ${Colors.Neutral10};
        `
      case 'darker':
        return css`
          background-color: ${Colors.Neutral15};
        `
      case 'darkest':
        return css`
          background-color: ${Colors.Neutral90};
        `
    }
  }}
`

export const StyledSegmentControl = styled(SegmentControl)<Props>`
  ${Typography.sizes.Caption};
  padding-top: ${Spacing['2XS']};
  padding-bottom: ${Spacing['2XS']};
  flex: ${({ $isFullWidth }) => ($isFullWidth ? `1 1 33.33%` : 'auto')};

  ${({ $theme }) => {
    switch ($theme) {
      case 'default':
        return css`
          --background-default: ${Colors.Neutral10};
        `
      case 'darker':
        return css`
          --background-default: ${Colors.Neutral15};
        `
      case 'darkest':
        return css`
          --background-default: ${Colors.Neutral90};
          --background-hover: ${Colors.Neutral100};
        `
    }
  }}
`
